
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';

import { DashboardComponent } from './dashboard.component';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FlexLayoutModule} from "@angular/flex-layout";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {FuseSidebarModule} from "../../../@fuse/components";
import {MatRippleModule} from "@angular/material/core";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatDialogModule} from "@angular/material/dialog";
import {MatToolbarModule} from "@angular/material/toolbar";
import {TranslateModule} from "@ngx-translate/core";
import {MatDividerModule} from "@angular/material/divider";
import {RouterModule} from "@angular/router";
import {ResourceOnlineDetailsModalComponent} from "./modal/resourceOnlineDetailsModal/resourceOnlineDetailsModal.component";
import {ResourceCalendarModalComponent} from "./modal/resourceCalendarModal/resourceCalendarModal.component";
import {ConfirmOpenSlotModalComponent} from "./modal/confirmOpenSlotModal/confirmOpenSlotModal.component";
import {UserWorkoutDetailsModalComponent} from "./modal/userWorkoutDetailsModal/userWorkoutDetailsModal.component";
import {DeviceStatsModalComponent} from "./modal/deviceStatsModal/deviceStatsModal.component";
import {DatePipe} from "@angular/common";
import {TrainingModule} from "../training/training.module";
import {ChartsModule} from "ng2-charts";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";

@NgModule({
    declarations: [
        DashboardComponent,
        ResourceOnlineDetailsModalComponent,
        ResourceCalendarModalComponent,
        ConfirmOpenSlotModalComponent,
        UserWorkoutDetailsModalComponent,
        DeviceStatsModalComponent,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        MatCheckboxModule,
        MatSelectModule,
        MatTooltipModule,
        MatDialogModule,
        MatToolbarModule,
        TranslateModule,
        MatDividerModule,
        RouterModule,
        TrainingModule,
        ChartsModule,
        MatProgressSpinnerModule,
    ],
    providers: [
        DatePipe
    ],
    bootstrap: [
        DashboardComponent
    ]
})
export class DashboardModule { }
